import React, {useState, useEffect, useContext} from 'react'
import AuthContext from '../context/AuthContext'
import axiosInstance from '../utils/axiosInstance'
import useAxios from '../utils/useAxios'
import EmployeePage from './EmployeePage'
import EmployerPage from './EmployerPage'

const HomePage = () => {
  let [notes, setNotes] = useState([])
  let {authTokens, logoutUser, user} = useContext(AuthContext)

  let api = useAxios()

  useEffect(() => {
    getNotes()
    console.log("this is the user: ", user)
  }, [])

  let getNotes = async () => {
    let response = await api.get('/api/notes/')
    // let response = await fetch('http://hamsieexpenses.com/api/notes/', {
    //   method: 'GET',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': 'Bearer ' + String(authTokens.access)
    //   }, 
    // })
    // in axios we don't need to parse the resposne so::
    // let data = await response.json()
    if (response.status === 200) {
      setNotes(response.data)
    }
    // else if (response.statusText === 'Unautharized' ) {
    //   logoutUser()
    // }
  }

  if (user.is_staff || user.is_reviewer) {
    return (
      <EmployerPage is_reviewer={user.is_reviewer} />
    )
  } else {
    return (
      <EmployeePage />
    )
  } 
}

export default HomePage